import { render } from "./certificat-list.vue?vue&type=template&id=f439ba90&scoped=true"
import script from "./certificat-list.vue?vue&type=script&lang=js"
export * from "./certificat-list.vue?vue&type=script&lang=js"

import "./certificat-list.vue?vue&type=style&index=0&id=f439ba90&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f439ba90"]])

export default __exports__